module.exports = __webpack_public_path__ + "assets/img/spritesheet-icons@2x.f790e24f.png";